import { useNavigate } from "react-router-dom";

/**
 * The single interrupting signal, sitting directly above the greeting.
 *
 * Deliberately capped at one: a stack of banners trains people to skip the
 * region. Everything below critical belongs in "Suas tarefas" or the notice
 * drawer, so whatever lands here is always worth stopping for.
 *
 * The pill is a frosted panel in both themes — translucent over the aurora so
 * the state colour still reads through it.
 *
 * External payment links open in a new tab; internal destinations route
 * in-app.
 */
export default function AlertPill({ alert }) {
  const navigate = useNavigate();
  if (!alert) return null;

  const isExternal = /^https?:\/\//.test(alert.href || "");

  const handleAction = () => {
    if (!alert.href) return;
    if (isExternal) {
      window.open(alert.href, "_blank", "noopener,noreferrer");
      return;
    }
    navigate(alert.href);
  };

  return (
    <output className="mb-7 inline-flex max-w-full flex-wrap items-center justify-center gap-[11px] rounded-[22px] border border-black/10 bg-white/70 py-[7px] pl-[15px] pr-[7px] shadow-sm backdrop-blur-xl dark:border-white/[.16] dark:bg-[#0a0a0f]/50 dark:shadow-none animate-rise motion-reduce:animate-none">
      <span
        className="h-1.5 w-1.5 flex-none rounded-full animate-breathe motion-reduce:animate-none"
        style={{ background: alert.color }}
      />
      <span className="text-[12.5px] font-semibold leading-[1.4] text-[#15161f] dark:text-white">
        {alert.text}
      </span>
      <span className="text-[12.5px] font-normal leading-[1.4] text-[#5c5f70] dark:text-white/50">
        {alert.detail}
      </span>
      <button
        type="button"
        onClick={handleAction}
        className="h-7 flex-none whitespace-nowrap rounded-[15px] border-0 bg-[#15161f] px-3.5 text-[11.5px] font-bold text-white transition-opacity hover:opacity-90 dark:bg-white dark:text-[#0a0a0f]"
      >
        {alert.cta}
      </button>
    </output>
  );
}
